import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'SHELTER_UPDATE',
    smsDelete : 'SHELTER_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        shelter: [],
        shelter_detail: {},

        submitSuccess: false,
        shelterLoading: false,
        shelterError: false,
        shelterDetailLoading: false,
        shelterDetailError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SHELTER(state, shelter) {
            state.shelter = shelter;
        },

        SET_SHELTER_DETAILS(state, shelter) {
            state.shelter_detail = shelter;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SHELTER_LOADING (state, loading) {
            state.shelterLoading = loading;
        },

        SHELTER_ERROR (state, hasError) {
            state.shelterError = hasError;
        },

        SHELTER_DETAILS_LOADING (state, loading) {
            state.shelterDetailLoading = loading;
        },

        SHELTER_DETAILS_ERROR (state, hasError) {
            state.shelterDetailError = hasError;
        }
    },

    actions: {
        async addShelter ({commit, dispatch}, payload) {
            commit('SHELTER_LOADING', true);
            commit('SHELTER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_shelter, payload.shelter, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchShelter')
                return response

            } catch (e) {
                commit('SHELTER_ERROR', true);
            } finally {
                commit('SHELTER_LOADING', false);
            }
        },

        async fetchShelter ({ commit }) {
            commit('SHELTER_LOADING', true);
            commit('SHELTER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.shelter_list, config);
                let response = result.data
                commit('SET_SHELTER', response.data);

            } catch(error) {
                commit('SHELTER_ERROR', true);
            } finally {
                commit('SHELTER_LOADING', false);
            }
        },

        async fetchShelterDetails ({ commit }, payload) {
            commit('SHELTER_DETAILS_LOADING', true);
            commit('SHELTER_DETAILS_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.shelter_details + payload, config);
                let response = result.data
                commit('SET_SHELTER_DETAILS', response.data);
                return response

            } catch(error) {
                commit('SHELTER_DETAILS_ERROR', true);
            } finally {
                commit('SHELTER_DETAILS_LOADING', false);
            }
        },

        async updateShelter ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_shelter + payload.id, payload.shelter, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchShelter')
                return response

            } catch (e) {
                commit('SHELTER_ERROR', true);
            } finally {
                commit('SHELTER_LOADING', false);
            }
        },
        
        async deleteShelter({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.shelter_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchShelter')
            return response
        }
    },

    getters: {}
}
